export default __webpack_public_path__ + "static/media/Dummy 1.525c667f.jpg";